import { render, staticRenderFns } from "./ProgramDetailGallery.vue?vue&type=template&id=96a37d3a&scoped=true&"
import script from "./ProgramDetailGallery.vue?vue&type=script&lang=js&"
export * from "./ProgramDetailGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProgramDetailGallery.vue?vue&type=style&index=0&id=96a37d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a37d3a",
  null
  
)

export default component.exports